<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      persistent
      scrollable
      max-width="800px"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          Wellness Leave <v-spacer></v-spacer>
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text
          style="max-height: 780px; max-width: 1300px; margin: 0 auto"
          class="mt-4"
        >
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-spacer></v-spacer>
              <!-- <v-text-field
                v-model="search"
                outlined
                prepend-inner-icon="search"
                label="Search"
                single-line
                hide-details
                class="mx-1 rounded-lg"
                color="#519043"
                dense
              ></v-text-field> -->
              <v-btn
                @click="
                  employeeListDialog = true;
                  action = 'Add';
                "
                :color="$vuetify.theme.themes.light.submitBtns"
                class="mx-1 white--text"
                :disabled="alreadyCreated"
              >
                <v-icon>mdi-plus</v-icon>
                ADD
              </v-btn>
            </v-col>
          </v-row>

          <v-card class="my-5 dt-container" elevation="0" outlined>
            <v-data-table
              :headers="headers1"
              :items="wellness_schedule"
              :items-per-page="10"
              :search="search"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                {{ formatDate(item.created_at) }}
              </template>
              <template v-slot:[`item.updated_at`]="{ item }">
                {{ formatDate(item.updated_at) }}
              </template>
              <template v-slot:[`item.date_schedule`]="{ item }">
                {{ formatDate(item.date_schedule) }}
              </template>

              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  v-if="$store.state.user.id == item.created_by"
                  @click="updateWellnessSchedule(item)"
                  class="mx-1"
                  x-small
                  color="blue"
                  outlined
                >
                  Update
                </v-btn>
                <v-btn
                  @click="viewWellnessSchedule(item)"
                  class="mx-1"
                  x-small
                  color="green"
                  outlined
                >
                  View
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            outlined
            @click="
              close();
              dialog = false;
            "
          >
            <v-icon>mdi-close-circle-outline</v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="employeeListDialog"
      persistent
      scrollable
      max-width="1300px"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <span>Employees Added on Wellness Schedule</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="employeeListDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text
          style="max-height: 780px; max-width: 1300px; margin: 0 auto"
          class="mt-4"
        >
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                outlined
                prepend-inner-icon="search"
                label="Search"
                single-line
                hide-details
                class="mx-1 rounded-lg"
                color="#519043"
                dense
              ></v-text-field>
              <v-btn
                @click="addWellness()"
                :color="$vuetify.theme.themes.light.submitBtns"
                class="mx-1 white--text"
                v-if="action == 'Add'"
              >
                <v-icon>{{
                  wellness_employeeList.length == 0 ? "mdi-plus" : "mdi-pencil"
                }}</v-icon>
                {{ wellness_employeeList.length == 0 ? "add" : "update" }}
              </v-btn>
              <v-btn
                @click="viewFileUploaded()"
                :color="$vuetify.theme.themes.light.submitBtns"
                class="mx-1 pa-3 white--text"
                v-if="action != 'Add'"
              >
                <v-icon medium class="mx-1 ">mdi-file</v-icon>
                Memo
              </v-btn>
            </v-col>
          </v-row>

          <v-card class="my-5 dt-container" elevation="0" outlined>
            <v-data-table
              :headers="action == 'Add' ? headers : headers2"
              :items="wellness_employeeList"
              :items-per-page="10"
              :search="search"
              :options.sync="options"
              :loading="loading"
              @pagination="pagination"
              hide-default-footer
            >
              <!-- <template v-slot:[`item.empID`]="{ item }">
                {{ getName(item.empID) }}
              </template> -->

              <template v-slot:[`item.created_at`]="{ item }">
                {{ formatDate(item.created_at) }}
              </template>
              <template v-slot:[`item.date_schedule`]="{ item }">
                {{ formatDate(item.date_schedule) }}
              </template>

              <template v-slot:[`item.date_filed`]="{ item }">
                {{ formatDate(item.date_filed) }}
              </template>

              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  @click="removeEmployee(item)"
                  class="mx-1"
                  x-small
                  color="red"
                  outlined
                  v-if="action == 'Add'"
                >
                  Remove
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
          <v-row class="mb-2 mx-5" align="center">
            <v-col
              cols="auto"
              class="mr-auto text-truncate flex-items"
              no-gutters
            >
              <span class="px-2">Show</span>
              <span>
                <v-select
                  dense
                  outlined
                  hide-details
                  :value="options.itemsPerPage"
                  style="max-width: 90px"
                  class="rounded-lg"
                  color="#519043"
                  @change="options.itemsPerPage = parseInt($event, 10)"
                  :items="perPageChoices"
                >
                </v-select>
              </span>
              <span class="px-2"> Entries </span>
            </v-col>
            <v-col cols="auto" class="mr-auto text-truncate" no-gutters>
              Showing {{ paginationData.pageStart + 1 }} to
              {{ paginationData.pageStop }} of
              {{ paginationData.itemsLength }} entries
            </v-col>
            <v-col cols="auto">
              <v-pagination
                v-model="options.page"
                class="rounded-lg"
                :total-visible="7"
                :color="$vuetify.theme.themes.light.submitBtns"
                :length="paginationData.pageCount"
              >
              </v-pagination>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="employeeListDialog = false">
            Close
          </v-btn>
          <v-btn
            :color="$vuetify.theme.themes.light.submitBtns"
            class="white--text"
            @click="submitWellness()"
            v-if="!alreadyCreated"
          >
            <v-icon>mdi-check-circle</v-icon>
            SUBMIT
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addWellnessDialog"
      eager
      scrollable
      persistent
      max-width="500px"
      transition="dialog-bottom-transition"
    >
      <v-form ref="WellnessFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>{{ action }} Wellness Schedule</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="addWellnessDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 800px" class="my-4">
            <v-row>
              <v-col cols="12" class="mt-2">
                <v-menu
                  ref="dateFiledRef"
                  :close-on-content-click="false"
                  :return-value.sync="date_filed"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      v-model="date_filed"
                      :rules="[formRules.required]"
                      chips
                      small-chips
                      label="Date"
                      color="#6DB249"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_filed"
                    no-title
                    color="#6DB249"
                    scrollable
                  >
                    <v-spacer></v-spacer>

                    <v-btn
                      text
                      color="#6DB249"
                      @click="$refs.dateFiledRef.save(date_filed)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="mt-2" cols="12" v-if="action == 'Add'">
                <v-file-input
                  v-model="memo"
                  label="File Upload / Memo
                          "
                  outlined
                  color="green"
                  dense
                  counter
                  prepend-icon="mdi-paperclip"
                  accept="application/pdf"
                  show-size
                  :rules="[formRules.required]"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip v-if="index < 2" color="green" dark label small>
                      {{ text }}
                    </v-chip>

                    <span
                      v-else-if="index === 2"
                      class="text-overline grey--text text--darken-3 mx-2"
                    >
                      +{{ files.length - 2 }} File(s)
                    </span>
                  </template>
                </v-file-input>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="addWellnessDialog = false">
              Close
            </v-btn>
            <v-btn
              @click="action == 'Add' ? save() : update()"
              :disabled="action == 'Add' ? !memo : updateTrue"
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
            >
              {{ action }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Confirmation </v-card-title>

        <v-card-text style="font-size: 17px">
          Are you sure you want to delete this item ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="teal darken-3"
            outlined
            @click="dialogConfirmDelete = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="red"
            class="white--text"
            @click="
              confirmDelete();
              dialogConfirmDelete = false;
            "
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmUpdate" max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Confirmation </v-card-title>

        <v-card-text style="font-size: 17px">
          Are you sure you want to update this schedule ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red" outlined @click="dialogConfirmUpdate = false">
            Cancel
          </v-btn>

          <v-btn
            color="teal darken-3"
            class="white--text"
            @click="
              confirmUpdate();
              dialogConfirmUpdate = false;
            "
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="loadingState" class="loading-overlay">
      <div class="spinner"></div>
      <p>Loading, please wait...</p>
    </div>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
  },
  data() {
    return {
      dialog: false,
      action: null,
      loadingState: false,
      employeeListDialog: false,
      dialogConfirmUpdate: false,
      options: {},
      search: "",
      paginationData: {},
      dialogConfirmDelete: false,
      memo: null,
      perPageChoices: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "20", value: 20 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "250", value: 250 },
        { text: "500", value: 500 },
      ],
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
          valign: "center",
        },

        {
          text: "Schedule",
          value: "date_filed",
          align: "center",
          valign: "center",
        },

        {
          text: "Action",
          value: "action",
          align: "end",
          valign: "end",
        },
      ],
      headers2: [
        {
          text: "Name",
          value: "name",
          align: "start",
          valign: "center",
        },

        {
          text: "Schedule",
          value: "date_filed",
          align: "end",
          valign: "end",
        },
      ],
      headers1: [
        {
          text: "Created by",
          value: "name",
          align: "start",
          valign: "center",
        },
        {
          text: "Wellness Schedule",
          value: "date_schedule",
          align: "center",
          valign: "center",
        },
        {
          text: "Date Created",
          value: "created_at",
          align: "center",
          valign: "center",
        },
        {
          text: "Date Updated",
          value: "updated_at",
          align: "center",
          valign: "center",
        },

        {
          text: "Action",
          value: "action",
          align: "end",
          valign: "end",
        },
      ],
      deleteIndex: null,
      loading: false,
      employeeList: [],
      wellness_employeeList: [],
      wellness_schedule: [],
      updateTrue: true,
      indexToUpdate: null,
      credits: null,
      date_filed: null,
      addWellnessDialog: false,
      alreadyCreated: false,
      updateData: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        // if (data) {
        console.log(data);
        this.action = "Add";
        this.dialog = true;
        this.loadPlantillaEmployees();
        this.getCreatedWellnessSchedule();
      },
      deep: true,
    },
    options: {
      handler() {},
      deep: true,
    },
    date_filed(newValue, oldValue) {
      if (oldValue !== null) {
        if (newValue !== oldValue) {
          this.updateTrue = false;
        }
      }
    },
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {},

    loadPlantillaEmployees() {
      this.axiosCall("/employee/getAllEmployeesActive", "GET").then((res) => {
        let data = res.data;
        data.forEach((element, i) => {
          data[i].name = this.toTitleCase(element.name);
        });
        this.employeeList = data;
      });
    },

    getCreatedWellnessSchedule() {
      //   let filter = this.$store.getters.getFilterSelected;
      this.axiosCall("/leave-credits/getCreatedWellnessSchedule", "GET").then(
        (res) => {
          if (res.data) {
            let data = res.data;
            data.forEach((element, i) => {
              data[i].name = this.toTitleCase(element.name);
            });
            this.wellness_schedule = data;
            for (let i = 0; i < this.wellness_schedule.length; i++) {
              console.log(this.wellness_schedule[i].date_schedule);
              const scheduleYear = new Date(
                this.wellness_schedule[i].date_schedule,
              ).getFullYear();
              const currentYear = new Date().getFullYear();
              if (scheduleYear === currentYear) {
                this.alreadyCreated = true;
                return;
              } else {
                this.alreadyCreated = false;
              }
            }
          }
        },
      );
    },

    close() {
      this.eventHub.$emit("closeWellnessDialog", false);
      this.wellness_employeeList = [];
      this.search = "";
      this.dialog = false;
    },

    getName(id) {
      let name;
      for (let i = 0; i < this.employeeList.length; i++) {
        if (this.employeeList[i].empID == id) {
          name = this.employeeList[i].name;
        }
      }
      return name;
    },

    addWellness() {
      this.addWellnessDialog = true;
      this.$refs.WellnessFormref.reset();
      this.$refs.WellnessFormref.resetValidation();
    },

    removeEmployee(item) {
      const index = this.wellness_employeeList.findIndex(
        (i) => i.empID === item.empID,
      );
      this.dialogConfirmDelete = true;
      console.log(index);
      this.deleteIndex = index;
    },

    confirmDelete() {
      this.dialogConfirmDelete = false;
      this.wellness_employeeList.splice(this.deleteIndex, 1);
    },

    save() {
      if (this.$refs.WellnessFormref.validate()) {
        if (this.wellness_employeeList.length > 0) {
          this.wellness_employeeList = [];
        }

        for (let i = 0; i < this.employeeList.length; i++) {
          this.wellness_employeeList.push({
            date_filed: this.date_filed,
            empID: this.employeeList[i].empID,
            userDetailID: this.employeeList[i].userID,
            name: this.employeeList[i].name,
          });
        }
        this.addWellnessDialog = false;
      }
    },

    submitWellness() {
      if (this.wellness_employeeList.length > 0) {
        let fd = new FormData();
        let data = {
          employeeList: this.wellness_employeeList,
          date_filed: this.date_filed,
        };
        fd.append("data", JSON.stringify(data));
        fd.append("file", this.memo);

        console.log(data);
        this.loadingState = true;
        this.axiosCall("/leave-credits/AddWellnessSchedule", "POST", fd).then(
          (res) => {
            if (res.data.status == 201) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              setTimeout(() => {
                this.loadingState = false;
                this.employeeListDialog = false;
                this.getCreatedWellnessSchedule();
              }, 1500);
            } else if (res.data.status == 400) {
              this.loadingState = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          },
        );
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "No Schedule Added!";
      }
    },

    updateWellnessSchedule(item) {
      this.action = "Update";
      console.log(item);
      this.date_filed = item.date_schedule;
      this.updateData = item;
      this.addWellnessDialog = true;
    },
    viewWellnessSchedule(item) {
      this.action = "View";
      this.updateData = item;
      this.axiosCall(
        "/leave-credits/getLeaeveCreditsWL/" + item.date_schedule,
        "GET",
      ).then((res) => {
        if (res.data) {
          let data = res.data;
          data.forEach((element, i) => {
            data[i].name = this.toTitleCase(element.name);
          });
          for (let i = 0; i < data.length; i++) {
            this.wellness_employeeList.push({
              date_filed: data[i].credit_date_for,
              empID: data[i].empID,
              name: data[i].name,
            });
          }
          this.employeeListDialog = true;
        }
      });
    },
    update() {
      this.dialogConfirmUpdate = true;
    },
    confirmUpdate() {
      let dataToChange = {
        oldData: this.updateData,
        newSchedule: this.date_filed,
      };
      let data = {
        data: JSON.stringify(dataToChange),
      };
      console.log("update", this.date_filed);
      this.loadingState = true;
      this.axiosCall(
        "/leave-credits/updateWellnessSchedule/" + this.updateData.id,
        "PATCH",
        data,
      ).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.getCreatedWellnessSchedule();
          setTimeout(() => {
            this.loadingState = false;
            this.dialogConfirmUpdate = false;
            this.addWellnessDialog = false;
          }, 1500);
        } else if (res.data.status == 400) {
          this.loadingState = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },
    viewFileUploaded() {
      let url =
        process.env.VUE_APP_SERVER +
        "/leave-credits/view/wellnessMemo/" +
        this.updateData.file_uploaded;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
      window.open(url);
    },
  },
};
</script>
<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}
table tr th,
table tr td {
  border-right: 1px solid #bbb;
  border-bottom: 1px solid #bbb;
  padding: 5px;
}

table tr th:first-child,
table tr td:first-child {
  border-left: 1px solid #bbb;
}
table tr th {
  background: #eee;

  border-top: solid 1px #bbb;
}

/* top-left border-radius */
table tr:first-child th:first-child {
  border-top-left-radius: 6px;
}

/* top-right border-radius */
table tr:first-child th:last-child {
  border-top-right-radius: 6px;
}

/* bottom-left border-radius */
table tr:last-child td:first-child {
  border-bottom-left-radius: 6px;
}

/* bottom-right border-radius */
table tr:last-child td:last-child {
  border-bottom-right-radius: 6px;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 6px solid #ccc;
  border-top: 6px solid #1976d2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
